import { useI18next } from "gatsby-plugin-react-i18next";

export const objectToSearchQeury = (utm_data: any) => {
  return Object.fromEntries(
    Object.entries(utm_data).filter(([_, v]) => v != null)
  );
};

export const useGtagNavigate = () => {
  const { navigate } = useI18next();

  return function (url: string) {
    typeof window !== "undefined" && window.gtag &&
      window.gtag("event", "conversion", {
        send_to:
          process.env.COVERSION_CODE || "AW-804845580/fUSUCLmG0oQBEIzw4_8C",
        debug_mode: process.env.GA_DEBUG_MODE || true,
      });

    navigate(url);
  };
};

export const gtag = () => {
  typeof window !== "undefined" && window.gtag &&
    window.gtag("event", "conversion", {
      send_to:
        process.env.COVERSION_CODE || "AW-804845580/fUSUCLmG0oQBEIzw4_8C",
      debug_mode: process.env.GA_DEBUG_MODE || true,
    });
};
